import PropTypes from 'prop-types';
import React from 'react';
import Card from 'components/Card';
import {
  InsightsHeader,
  InsightsTitle,
  InsightsText,
  InsightsSubtext,
  LearnMore,
  ExpandButton,
} from '../Customers/StyledComponents';

const ProTipCard = ({ onLearnMore }) => {
  return (
    <Card
      accent
      style={{
        cursor: 'pointer',
        marginBottom: '30px'
      }}
      onClick={onLearnMore}
    >
      <InsightsHeader>
        <InsightsTitle>PRO TIP</InsightsTitle>
        <ExpandButton
          onClick={(e) => {
            e.stopPropagation();
            onLearnMore();
          }}
        >
          <svg
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </ExpandButton>
      </InsightsHeader>
      <InsightsText>
        Filter + Quick Actions = Targeted Campaigns
      </InsightsText>
      <InsightsSubtext>
        1. Use table filters to select customers
        <br />
        2. Click Quick Actions
        <br />
        3. Send targeted message
      </InsightsSubtext>
      <LearnMore
        onClick={(e) => {
          e.preventDefault();
          onLearnMore();
        }}
      >
        Why this matters
        <svg
          width="12"
          height="12"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </LearnMore>
    </Card>
  );
};

ProTipCard.propTypes = {
  onLearnMore: PropTypes.func.isRequired,
};

export default ProTipCard;